import { Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import FeaturesModal from "../Modals/FeaturesModal";
import dataTableData from "../data/features";
import DataTable from "../DataTable";
import { Add, TipsAndUpdates } from "@mui/icons-material";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";

function Features({ superadmin_data }) {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [suggestion, setSuggestion] = useState(false);

  const handleSubmit = async (category) => {
    const payload = {
      type: "agency",
      name: category.name,
      score: category.score,
      agency_id: agency._id,
    };
    const { response } = await AppService.health_features.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleRefresh();
    }
  };
  return (
    <SoftBox>
      <Grid container rowSpacing={3}>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          {/* <SoftBox mr={1}>
            <TipsAndUpdates sx={{ cursor: "pointer" }} onClick={() => setSuggestion(!suggestion)} />
          </SoftBox> */}
          <FeaturesModal handleRefresh={handleRefresh} />
        </Grid>
        <Grid
          sx={{ overflowX: "auto", marginTop: "20px", paddingBottom: "12px" }}
          className="hideScroll"
        >
          <Stack direction="row" spacing={1}>
            {superadmin_data?.filter((item) => !main_data?.some((main_data) => main_data?.name === item?.name))?.map((category) => (
              <Chip
                key={category._id}
                label={category?.name}
                icon={<Add />}
                onClick={() => handleSubmit(category)}
                sx={{ cursor: "pointer" }}
                variant="outlined"
              />
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <DataTable table={data} canSearch />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Features;
